import React, { useState, useEffect } from 'react';
import logo from '../assets/sslogo.jpeg';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
      setMenuOpen(false);
    }
  };

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <a href="#home" className="logo"><img src={logo} alt="Splendid Services Logo" className="logo-img" /></a>

        <div
          className="hamburger"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>

        <ul className={`nav-links ${menuOpen ? 'active' : ''}`}>
          <li>
            <a href="#home" onClick={() => scrollToSection('home')}>
              Home
            </a>
          </li>
          <li>
            <a href="#directors" onClick={() => scrollToSection('directors')}>
              Directors
            </a>
          </li>
          <li>
            <a href="#services" onClick={() => scrollToSection('services')}>
              Services
            </a>
          </li>
          <li>
            <a href="#about" onClick={() => scrollToSection('about')}>
              About
            </a>
          </li>
          <li>
            <a href="#testimonials" onClick={() => scrollToSection('testimonials')}>
              Testimonials
            </a>
          </li>
          <li>
            <a
              href="#contact"
              className="nav-cta"
              onClick={() => scrollToSection('contact')}
            >
              Get a Quote
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;